module.exports = __webpack_public_path__ + "media/common/fonts/social/social-8e9e797e45ca1babb92280171c9b8e4f.svg";